import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-undo-dialog',
  templateUrl: './undo-dialog.component.html',
  styleUrls: ['./undo-dialog.component.scss']
})
export class UndoDialogComponent implements OnInit {

  @Input() description: string;
  @Output() close = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() { }

}


// WEBPACK FOOTER //
// ./src/app/transfers/undo-dialog.component.ts